import { render } from "./render_main_sections.html?vue&type=template&id=fca5ab84&scoped=true&external"
import script from "./render_main_sections.js?vue&type=script&lang=js&external"
export * from "./render_main_sections.js?vue&type=script&lang=js&external"

import "./RenderMainSections.vue?vue&type=style&index=0&id=fca5ab84&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fca5ab84"]])

export default __exports__